import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

function NdcDetailsModal(props: any) {
  const [data, setData]: any = useState({
    ndc: "",
    product: "",
    deaClass: null,
  });
  const [errorNDCMessage, setErrorNDCMessage] = useState("");
  const [errorDEAMessage, setErrorDEAMessage] = useState("");

  const inputChange = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "ndc") {
      if (!/^\d{11}$/.test(value)) {
        setErrorNDCMessage("NDC number must be exactly 11 digits");
        setData((values: any) => ({ ...values, [name]: "" }));
      } else if(Number(value) === 0) {
        setErrorNDCMessage("NDC number cannot be all zeros");
        setData((values: any) => ({ ...values, [name]: "" }));
      } else {
        setErrorNDCMessage("");
        setData((values: any) => ({ ...values, [name]: value }));
      }
    } else if (name === "deaClass") {
      if (Number.isNaN(Number(value))) {
        setErrorDEAMessage("DEA Class must be a number");
        setData((values: any) => ({ ...values, [name]: "" }));
      } else if (value === "1") {
        setErrorDEAMessage("DEA Class 1 is not allowed");
        setData((values: any) => ({ ...values, [name]: "" }));
      } else if (value !== "" && !["0", "2", "3", "4", "5"].includes(value)) {
        setErrorDEAMessage("DEA Class value must be one of the following: 0, 2, 3, 4, or 5");
        setData((values: any) => ({ ...values, [name]: "" }));
      } else {
        setErrorDEAMessage("");
        setData((values: any) => ({ ...values, [name]: value }));
      }
    } else {
      setData((values: any) => ({ ...values, [name]: value }));
    }
  };
  const handleNoCopyPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
  };
  const handleTextOnlyKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const invalidChars = ['<', '>', '/', '\\', '{', '}', '(', ')', ';', '"', "'", '`'];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };
  const handleNumberOnlyKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const invalidChars = ["e", "E", ".", "+", "-"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <Modal
      show={props.detailModalShow}
      onHide={() => props.handleClose(data)}
      className="custom_modal"
    >
      <Modal.Header className="custom_modal_header">
        <Modal.Title className="custom_modal_header_title">
          <div className="custom_modal_header_title_left">NDC Details</div>
          <div className="custom_modal_header_title_right">
            <Button variant="link" onClick={() => props.handleClose(data)}>
              <i className="fa-solid fa-times"></i>
            </Button>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom_modal_body">
        <Form className="form_box">
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
            <Form.Label>NDC</Form.Label>
            <Form.Control
              type="number"
              placeholder=""
              name="ndc"
              maxLength={11}
              onChange={(e) => inputChange(e)}
              onKeyDown={handleNumberOnlyKeyDown}
            />
            {errorNDCMessage && (
              <p className="error-validation">{errorNDCMessage}</p>
            )}
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
            <Form.Label>Product</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              name="product"
              maxLength={255}
              onChange={(e) => inputChange(e)}
              onKeyDown={handleTextOnlyKeyDown}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
            <Form.Label>DEA Class</Form.Label>
            <Form.Control
              type="number"
              placeholder=""
              name="deaClass"
              min={0}
              max={5}
              maxLength={1}
              onChange={(e) => inputChange(e)}
              onKeyDown={handleNumberOnlyKeyDown}
              onPaste={handleNoCopyPaste}
            />
            {errorDEAMessage && (
              <p className="error-validation">{errorDEAMessage}</p>
            )}
          </Form.Group>
        </Form>
        {props.errorMessage && (
          <p className="error-validation">{props.errorMessage}</p>
        )}
      </Modal.Body>
      <Modal.Footer className="custom_modal_footer">
        <Button
          variant="primary"
          onClick={(e) => props.handleSave(e, data)}
          disabled={
            errorDEAMessage === "" && errorNDCMessage === "" ? false : true
          }
        >
          Save
        </Button>
        <Button variant="secondary" onClick={() => props.handleClose(data)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NdcDetailsModal;
